export const TRANSLATE = "TRANSLATE";
export const GET_ALL_TRANSLATED_PAGES = "GET_ALL_TRANSLATED_PAGES";
export const UPDATE_TRANSLATED_PAGE = "UPDATE_TRANSLATED_PAGE";
export const GET_ERRORS = "GET_ERRORS";
export const DELETE_TRANSLATE_PAGE = "DELETE_TRANSLATE_PAGE";
export const GET_PAGE_BY_ID = "GET_PAGE_BY_ID";

